/**
 * @GENERATED from Figma node 693:15991
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const BraveBright = function (props: IconProps, ref: React.Ref<SVGSVGElement>) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        d="m21 8.794-.651-1.76.453-1.008a.35.35 0 0 0-.07-.384L19.5 4.404a1.99 1.99 0 0 0-2.072-.479l-.337.119-1.88-2.026L12 2l-3.211.025L6.91 4.068l-.334-.118a2 2 0 0 0-2.085.482l-1.26 1.262A.275.275 0 0 0 3.176 6l.473 1.048L3 8.806l2.329 8.807c.22.832.726 1.561 1.43 2.06l4.606 3.105a1.02 1.02 0 0 0 1.274 0l4.603-3.11a3.65 3.65 0 0 0 1.428-2.06l1.9-7.224z"
      />
      <path
        fill="#fff"
        d="M12.526 15.016a3 3 0 0 0-.376-.135h-.226a3 3 0 0 0-.376.135l-.57.236-.643.294-1.047.543a.2.2 0 0 0-.14.176.2.2 0 0 0 .114.193l.91.636q.29.204.559.441l.256.22.536.466.243.213a.42.42 0 0 0 .534 0l1.047-.91.56-.442.91-.647a.197.197 0 0 0-.027-.366l-1.046-.525-.647-.295zm6.45-5.83.033-.094a2.5 2.5 0 0 0-.024-.377 3 3 0 0 0-.338-.633l-.591-.864-.422-.57-.793-.984a3 3 0 0 0-.235-.273h-.016l-.353.065-1.743.334a1.4 1.4 0 0 1-.519-.076l-.957-.308-.685-.188a3 3 0 0 0-.605 0l-.687.19-.957.31a1.4 1.4 0 0 1-.519.075l-1.741-.328-.352-.065h-.017a3 3 0 0 0-.235.274l-.791.984a9 9 0 0 0-.419.57l-.593.863-.28.464q-.075.27-.08.548l.033.094q.021.09.054.178l.468.534 2.071 2.19a.59.59 0 0 1 .105.588l-.347.798a1.03 1.03 0 0 0-.017.656l.068.186c.111.3.302.566.552.769l.326.264a.62.62 0 0 0 .591.07l1.157-.55q.321-.159.593-.39l.927-.83a.37.37 0 0 0 .02-.53l-2.093-1.402a.4.4 0 0 1-.127-.51l.81-1.516a.78.78 0 0 0 .042-.601.92.92 0 0 0-.462-.415l-2.542-.952c-.183-.065-.173-.147.021-.159L8.8 7.428c.234-.015.47.006.697.061l1.299.361a.4.4 0 0 1 .278.442l-.51 2.773a1.4 1.4 0 0 0-.025.468c.02.066.195.148.386.194l.791.164c.23.042.466.042.695 0l.712-.164c.192-.041.364-.133.386-.2a1.4 1.4 0 0 0-.026-.467l-.514-2.772a.394.394 0 0 1 .278-.441l1.3-.363c.227-.055.462-.076.696-.061l1.493.138c.195.018.206.09.022.16l-2.541.956a.9.9 0 0 0-.46.415.8.8 0 0 0 .04.602l.813 1.516a.4.4 0 0 1-.127.511l-2.09 1.404a.37.37 0 0 0 .014.524l.006.006.927.832q.273.23.592.388l1.157.547a.62.62 0 0 0 .592-.072l.325-.264c.25-.203.441-.47.552-.771l.068-.186c.066-.214.06-.445-.016-.656l-.34-.8a.59.59 0 0 1 .105-.588l2.071-2.192.466-.534q.037-.084.064-.174z"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={2.999}
          x2={21.015}
          y1={12.473}
          y2={12.473}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1562B" />
          <stop offset={0.3} stopColor="#F1542B" />
          <stop offset={0.41} stopColor="#F04D2A" />
          <stop offset={0.49} stopColor="#EF4229" />
          <stop offset={0.5} stopColor="#EF4029" />
          <stop offset={0.56} stopColor="#E83E28" />
          <stop offset={0.67} stopColor="#E13C26" />
          <stop offset={1} stopColor="#DF3C26" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(BraveBright);
export { ForwardRef as BraveBright };
